<template>
  <div id="projectTemplateMenuTmpl">
    <div class="menu" @click="handleMenuWrapperOnClick($event)">
      <!-- Menu Items -->
      <el-form :model="menuData" ref="projectTemplateMenu" id="projectTemplateMenu"
        @submit.prevent>

        <!-- Has Menu Items-->
        <template v-if="menuItems?.length">
          <el-form-item
            v-for="(menuItem, menuItemKey) in menuItems"
            :id="menuItem.id"
            :key="menuItemKey"
            class="property">

            <!-- Menu Item Content -->
            <el-col class="content common">
              <!-- Menu Item with multiple properties, so we need to map the properties -->
              <el-form-item v-if="menuItem.hasOwnProperty('array')" prop="media" class="form-item with-multiple-properties">
                <div class="editable">
                  <div
                    v-for="(dataProp, dataPropKey) in menuData[menuDataSourceKey][screenIndex][menuItem.id] ?? []"
                    :key="dataPropKey" :class="{'sub-property' : true,
                    'is-selected': (menuItem._arrayProperties.selectedPropertyKey === dataPropKey)}">
                    <!-- Set Label -->
                    <el-tag @click="handleMenuItemMultiPropertyClick(menuItemKey, dataPropKey)"
                      closable
                      @close="handleMenuItemMultiPropertyDeleteClick(menuItemKey, menuItem.id, dataPropKey)"
                      class="cstm-tag-grey ia-prop-name-tag">
                      {{ dataProp[menuItem._arrayProperties.labelSource] }}
                    </el-tag>

                    <!-- Map Multiple Properties -->
                    <div v-for="(itemPropIsArr, itemPropIsArrKey) in menuItem.properties"
                      :key="itemPropIsArrKey" class="ia-prop-content">
                      <!-- Input Element -->
                      <el-form-item v-if="itemPropIsArr.type === 'string'" :prop="itemPropIsArr.name">
                        <el-input
                          v-model="dataProp[itemPropIsArr.name]"
                          :placeholder="itemPropIsArr.name"
                          :ref="`${itemPropIsArr.name}-${itemPropIsArrKey}-input`"
                          @focus="handleInputElFocus(`${itemPropIsArr.name}-${itemPropIsArrKey}-input`)"
                          @change="handleMenuItemChange($event)" class="cstm-input-grey">
                        </el-input>
                      </el-form-item>

                      <!-- Color Element -->
                      <div v-if="itemPropIsArr.type === 'color' && !itemProperty.uiGroupId"
                        class="cstm-color-picker-wrapper cpicker-et-group-1-wrapper">
                        <el-color-picker
                          v-model="dataProp[itemPropIsArr.name]"
                          :prop="itemPropIsArr.name"
                          :show-alpha="(itemPropIsArr.name === 'backgroundColor')"
                          color-format="rgb"
                          :predefine="predefineColors"
                          :popper-class="getColorPickerPopperClass(itemProperty)"
                          :class="{'color-item': true, ['color-type-'+itemPropIsArr.colortype]: true }">
                        </el-color-picker>
                      </div>
                    </div>
                  </div>

                  <!-- Add More Sub Property -->
                  <el-button v-if="menuData[menuDataSourceKey][screenIndex][menuItem.id].length < menuItem.max"
                    @click="handleAddMoreSubPropertyInMenuItemClick(menuItemKey, menuItem.id, menuItem.max)"
                    icon="Plus" class="add-more-prop-btn cstm-btn-grey width-125">
                  </el-button>
                </div>
              </el-form-item>

              <!-- Property is not an array type or no sub properties -->
              <el-form-item v-if="!menuItem.hasOwnProperty('array')" prop="media" class="form-item single-type">
                <div class="editable">
                  <div v-if="menuItem.properties && menuItem.properties.length > 0 && !ifOnlyDurationInProperty(menuItem.properties) && !isMediaItem(menuItem.id) && !isWarningItem(menuItem.id) && !menuItem.isHidden" class="section-wrapper">
                    <!-- Section label for Webpage Settings -->
                    <label v-if="menuItem.properties.map(item => item.name).includes('frameWidth') && menuItem.properties.map(item => item.name).includes('href')"
                      class="section-label">
                      {{$t('template.webpageSettings')}}
                    </label>

                    <label v-if="menuItem.style === 'qrcode'" class="section-label">{{$t('template.qrSettings')}}</label>

                    <label v-else-if="menuItem.style === 'rss'" class="section-label">
                      <span class="flex-1">{{ menuItem.label }}</span>
                      <el-popover
                        class="hover:text-black"
                        popper-class="custom-popover-popper"
                        placement="bottom"
                        width="300"
                        trigger="hover"
                        :title="$t('label.importantToNote')">
                        <template #reference>
                          <font-awesome-icon class="px-2" icon="fa-solid fa-question" size="lg" />
                        </template>
                        <template #default>
                          <p v-html="$t('template.rssSettingsTooltip', { productName })"></p>
                        </template>
                      </el-popover>
                    </label>

                    <label v-else-if="menuItem.label" class="section-label">{{ menuItem.label }}</label>

                    <!-- Grouped Properties (should skip duration because it's standalone) -->
                    <div
                      v-for="(itemProperty, iPropKey) in filterOutByPropertyName(menuItem.properties, 'dur')"
                      :key="iPropKey"
                      :class="['with-single-property', itemProperty.labelPosition, `${menuItem.style}-${itemProperty.name}-${itemProperty.type}`]"
                      :id="`${menuItem.id}_${itemProperty.name}`">
                      <!-- Static Element -->
                      <el-form-item v-if="itemProperty.type === 'static'" :prop="itemProperty.name" :class="[itemProperty.labelPosition]">
                        <label v-if="itemProperty.label" class="label-property">{{itemProperty.label}}</label>
                        <div class="property-field static-value" v-if="menuData[menuDataSourceKey][screenIndex][menuItem.id]">{{menuData[menuDataSourceKey][screenIndex][menuItem.id][itemProperty.name]}}</div>
                      </el-form-item>

                      <!-- Input Element -->
                      <el-form-item v-if="itemProperty.type === 'string' && !itemProperty.hasOwnProperty('textarea')" :prop="itemProperty.name" :class="[itemProperty.labelPosition]">
                        <label v-if="itemProperty.label" class="label-property">{{itemProperty.label}}</label>
                        <el-input
                          v-if="menuData[menuDataSourceKey][screenIndex][menuItem.id]"
                          v-model="menuData[menuDataSourceKey][screenIndex][menuItem.id][itemProperty.name]"
                          :ref="`${menuItem.id + &quot;_&quot; + itemProperty.name}-input`"
                          :placeholder="itemProperty.placeholder ? $t(itemProperty.placeholder) : ''"
                          @focus="handleInputElFocus(`${menuItem.id + &quot;_&quot; + itemProperty.name}-input`)"
                          @change="handleMenuItemChange($event, itemProperty.type, itemProperty.name, menuItem.id)"
                          class="cstm-input-grey">
                        </el-input>
                      </el-form-item>

                      <!-- Textarea Element -->
                      <el-form-item v-if="itemProperty.type === 'string' && itemProperty.hasOwnProperty('textarea')" :prop="itemProperty.name">
                        <el-input
                          v-if="menuData[menuDataSourceKey][screenIndex][menuItem.id]"
                          v-model="menuData[menuDataSourceKey][screenIndex][menuItem.id][itemProperty.name]"
                          type="textarea"
                          autosize
                          @change="handleMenuItemChange($event)"
                          class="cstm-textarea-grey no-border-default">
                        </el-input>
                      </el-form-item>

                      <!-- Boolean type but as Switch Element -->
                      <el-form-item v-if="itemProperty.type === 'boolean' && !itemProperty.icon" :prop="itemProperty.name"
                        :label="itemProperty.label" class="switch-type">
                        <el-switch
                          v-if="menuData[menuDataSourceKey][screenIndex][menuItem.id]"
                          v-model="menuData[menuDataSourceKey][screenIndex][menuItem.id][itemProperty.name]"
                          @change="handleMenuItemChange($event)"
                          class="cstm-switch-grey">
                        </el-switch>
                      </el-form-item>
                      <el-form-item v-else-if="itemProperty.type === 'boolean' && itemProperty.icon" :prop="itemProperty.name"
                        :label="itemProperty.label" :class="['switch-type with-icon', `${itemProperty.icon.replace(/\.[^/.]+$/, '')}`]">
                        <el-switch
                          v-if="menuData[menuDataSourceKey][screenIndex][menuItem.id]"
                          v-model="menuData[menuDataSourceKey][screenIndex][menuItem.id][itemProperty.name]"
                          @change="handleMenuItemChange($event)"
                          class="cstm-switch-grey">
                        </el-switch>
                      </el-form-item>

                      <!-- Color Element -->
                      <div v-if="itemProperty.type === 'color' && !itemProperty.uiGroupId" class="cstm-color-picker-wrapper">
                        <el-color-picker
                          v-if="menuData[menuDataSourceKey][screenIndex][menuItem.id]"
                          :prop="itemProperty.name"
                          :model-value="menuData[menuDataSourceKey][screenIndex][menuItem.id][itemProperty.name]"
                          @active-change="handleColorSwatchChange($event, menuData[menuDataSourceKey][screenIndex][menuItem.id], itemProperty.name )"
                          :show-alpha="(itemProperty.name === 'backgroundColor')"
                          color-format="rgb"
                          :predefine="predefineColors"
                          :popper-class="getColorPickerPopperClass(itemProperty)"
                          :class="{'color-item': true, ['color-type-'+itemProperty.colortype]: true }">
                        </el-color-picker>
                      </div>

                      <!-- Date Element -->
                      <el-form-item v-if="itemProperty.type === 'date' && !itemProperty.uiGroupId" :prop="itemProperty.name" :label="itemProperty.label" class="date-picker">
                        <el-date-picker :prop="itemProperty.name"
                          :ref="`form-el-${itemProperty.name}`"
                          v-if="menuData[menuDataSourceKey][screenIndex][menuItem.id]"
                          v-model="menuData[menuDataSourceKey][screenIndex][menuItem.id][itemProperty.name]"
                          value-format="yyyy-MM-dd"
                          format="dd MMM yyyy"
                          @change="handleMenuItemChange($event)"
                          type="date"
                          :placeholder="''"
                          class="cstm-datepicker-grey">
                        </el-date-picker>
                      </el-form-item>

                      <!-- Time Element -->
                      <el-form-item v-if="itemProperty.type === 'time' && !itemProperty.uiGroupId" :prop="itemProperty.name" :label="itemProperty.label" class="time-picker">
                        <el-time-picker
                          v-if="menuData[menuDataSourceKey][screenIndex][menuItem.id]"
                          arrow-control
                          :prop="itemProperty.name"
                          v-model="menuData[menuDataSourceKey][screenIndex][menuItem.id][itemProperty.name]"
                          format="HH:mm"
                          value-format="HH:mm"
                          :id="'editProjectTimePicker'"
                          :ref="'editProjectTimePicker'"
                          :placeholder="''"
                          :prefix-icon="''"
                          :popper-class="'edit-project-time-picker-dropdown'"
                          @focus="handleTimePickerFocus(menuItem.id, itemProperty.name)"
                          @change="handleMenuItemChange($event)"
                          class="time-picker">
                        </el-time-picker>
                      </el-form-item>

                      <!-- URL Element -->
                      <el-form-item v-if="itemProperty.type === 'url'" :prop="itemProperty.name">
                        <label
                          v-if="menuItem.id === 'rss' && itemProperty.name === 'url'"
                          class="label-property uppercase text-xs text-gray-400 mr-2"
                        >
                          {{ $t('template.url') }}
                        </label>
                        <el-input
                          v-if="menuData[menuDataSourceKey][screenIndex][menuItem.id]"
                          v-model="menuData[menuDataSourceKey][screenIndex][menuItem.id][itemProperty.name]"
                          @change="handleMenuItemChange($event)"
                          :ref="`${menuItem.id + &quot;_&quot; + itemProperty.name}-input`"
                          @focus="handleInputElFocus(`${menuItem.id + &quot;_&quot; + itemProperty.name}-input`)"
                          class="cstm-input-grey"
                          :class="{ 'h-[30px]!': menuItem.id === 'rss' }">
                        </el-input>
                      </el-form-item>

                      <!-- Number Element -->
                      <el-form-item v-if="itemProperty.type === 'number'" :prop="itemProperty.name">
                        <el-input-number
                          v-if="menuData[menuDataSourceKey][screenIndex][menuItem.id]"
                          v-model="menuData[menuDataSourceKey][screenIndex][menuItem.id][itemProperty.name]"
                          @change="handleMenuItemNumberChange($event, menuItem.id, itemProperty.name)"
                          :min="itemProperty.min"
                          :max="itemProperty.max"
                          :step="1"
                          class="cstm-number-grey">
                        </el-input-number>
                      </el-form-item>

                      <!-- Selectbox Element -->
                      <el-form-item v-if="itemProperty.type === 'choice' && !itemProperty.uiGroupId" :prop="itemProperty.name" :class="[itemProperty.labelPosition]">
                        <label v-if="itemProperty.label" class="label-property">{{itemProperty.label}}</label>
                        <el-select v-if="menuItem.id === 'rss' && itemProperty.name === 'url' && !isItemInEditMode(menuItem)"
                          v-model="menuItem.selectedLang"
                          filterable
                          :popper-class="'cstm-selectbox-grey-popper ' + itemProperty.labelPosition"
                          class="cstm-selectbox-grey url_lang"
                          @change="handleMenuItemChange($event, itemProperty.type, 'rssLang', menuItem.id)">

                          <!-- Options from Property Values -->
                          <el-option v-for="(itemPropertyValue, itemPropValKey) in [...new Set(itemProperty.values.map((propValue) => propValue.lang))]"
                            :key="itemPropValKey" :label="itemPropertyValue"
                            :value="itemPropertyValue">
                            <span>{{ $utils.getCountryLanguage(itemPropertyValue) ?? '-' }}</span>
                          </el-option>
                        </el-select>

                        <el-select
                          v-if="!menuItem.displayId && menuData[menuDataSourceKey][screenIndex][menuItem.id]"
                          v-model="menuData[menuDataSourceKey][screenIndex][menuItem.id][itemProperty.name]"
                          :placeholder="itemProperty.name"
                          filterable
                          @change="handleMenuItemChange($event, itemProperty.type, itemProperty.name)"
                          :popper-class="'cstm-selectbox-grey-popper ' + itemProperty.labelPosition"
                          class="cstm-selectbox-grey">

                            <!-- Options from Property Values -->
                            <el-option v-for="(itemPropertyValue, itemPropValKey) in itemProperty.values.filter((propValue) => {
                              if (menuItem.id !== 'rss' || !menuItem.selectedLang || isItemInEditMode(menuItem)) return true

                              return propValue.lang === menuItem.selectedLang
                            })"
                              :key="itemPropValKey" :label="itemPropertyValue.name"
                              :value="itemPropertyValue.value">
                            </el-option>
                        </el-select>

                        <!-- Selectbox for Language Weather -->
                        <div v-else class="selectbox-with-label">
                            <label>{{ $t('label.language') }}</label>
                            <el-select
                              v-if="menuData[menuDataSourceKey][screenIndex][menuItem.displayId]"
                              v-model="menuData[menuDataSourceKey][screenIndex][menuItem.displayId][itemProperty.name]"
                              :placeholder="itemProperty.name"
                              filterable
                              @change="handleMenuItemChange($event, itemProperty.type, itemProperty.name)"
                              :popper-class="'cstm-selectbox-grey-popper ' + itemProperty.labelPosition"
                              class="cstm-selectbox-grey">

                              <!-- Options from Property Values -->
                              <el-option v-for="(itemPropertyValue, itemPropValKey) in itemProperty.values.filter((propValue) => {
                                if (menuItem.id !== 'rss' || !menuItem.selectedLang || isItemInEditMode(menuItem)) return true

                                return propValue.lang === menuItem.selectedLang
                              })"
                                :key="itemPropValKey" :label="itemPropertyValue.name"
                                :value="itemPropertyValue.value">
                              </el-option>
                            </el-select>
                        </div>
                      </el-form-item>

                      <!-- Switch type but as Radio Element -->
                      <template v-if="itemProperty.type === 'switch'">
                        <template v-if="menuItem.id === 'rss' && itemProperty.name === 'urlType'">
                          <el-form-item
                            v-if="showProjectCustomRSSOption"
                            :prop="itemProperty.name"
                          >
                            <!-- RSS URL Type Switch -->
                            <el-radio-group
                              :model-value="menuData[menuDataSourceKey][screenIndex][menuItem.id][itemProperty.name]"
                              @change="handleSwitchValueChange($event, menuDataSourceKey, screenIndex, menuItem.id, itemProperty.name, itemProperty.type)"
                              :class="[
                                'cstm-radio-grey',
                                'auto-button-width',
                                'w-full',
                                'mt-0',
                                itemProperty.name,
                              ]">

                              <el-radio-button v-for="(itemPropertyValue, itemPropValKey) in itemProperty.values"
                                :key="itemPropValKey"
                                size="small"
                                :class="[
                                  'flex-1',
                                  `${itemProperty.name}-${itemPropertyValue.value}`,
                                ]"
                                :label="itemPropertyValue.value"
                                :value="itemPropertyValue.value"
                              >
                                <div class="flex items-center justify-center text-xs! gap-2">
                                  <BaseIconSvg
                                    :name="itemPropertyValue.value === 'choice' ? 'flowbite:list-outline': 'flowbite:link-outline'"
                                    class="w-4! h-4!"
                                  />
                                  <span>{{ itemPropertyValue.nameTranslated ? itemPropertyValue.nameTranslated : itemPropertyValue.name.trim() }}</span>
                                </div>
                              </el-radio-button>
                            </el-radio-group>
                          </el-form-item>
                        </template>

                        <el-form-item
                          v-else-if="!itemProperty.uiGroupId && (isItemInEditMode(menuItem) || (!isItemInEditMode(menuItem) && !['effectName', 'effectDir'].includes(itemProperty.name)))"
                          :prop="itemProperty.name"
                        >
                        <el-radio-group
                          v-if="!menuItem.displayId && menuData[menuDataSourceKey][screenIndex][menuItem.id]"
                          :model-value="menuData[menuDataSourceKey][screenIndex][menuItem.id][itemProperty.name]"
                          @change="handleSwitchValueChange($event, menuDataSourceKey, screenIndex, menuItem.id, itemProperty.name, itemProperty.type)"
                          :class="['cstm-radio-grey', {'radio-constant-width': !itemProperty.small, 'auto-button-width': itemProperty.small}, itemProperty.name,
                          { 'extended-menu-item': itemProperty.extended }]">

                          <el-radio-button v-for="(itemPropertyValue, itemPropValKey) in itemProperty.values"
                            :key="itemPropValKey"
                            size="small"
                            :class="`${itemProperty.name}-${itemPropertyValue.value}`"
                            :label="itemPropertyValue.value"
                            :value="itemPropertyValue.value">
                            <template v-if="itemPropertyValue.nameTranslated">{{itemPropertyValue.nameTranslated}}</template>
                            <template v-else>{{itemPropertyValue.name.trim()}}</template>
                          </el-radio-button>
                        </el-radio-group>

                        <el-radio-group v-if="menuItem.displayId && menuData[menuDataSourceKey][screenIndex][menuItem.id]"
                          :model-value="menuData[menuDataSourceKey][screenIndex][menuItem.displayId][itemProperty.name]"
                          @change="handleSwitchValueChange($event, menuDataSourceKey, screenIndex, menuItem.displayId, itemProperty.name, itemProperty.type)"
                          :class="['cstm-radio-grey', {'radio-constant-width': !itemProperty.small, 'auto-button-width': itemProperty.small}, itemProperty.name,
                          { 'extended-menu-item': itemProperty.extended }]">
                          <el-radio-button v-for="(itemPropertyValue, itemPropValKey) in itemProperty.values"
                            :key="itemPropValKey"
                            size="small"
                            :class="`${itemProperty.name}-${itemPropertyValue.value}`"
                            :value="itemPropertyValue.value">
                              <template v-if="itemPropertyValue.nameTranslated">{{itemPropertyValue.nameTranslated}}</template>
                              <template v-else>{{itemPropertyValue.name.trim()}}</template>
                          </el-radio-button>
                        </el-radio-group>
                        </el-form-item>
                      </template>

                      <!-- City - a Selectbox Element with object value -->
                      <el-form-item v-if="itemProperty.type === 'cityid'" :prop="itemProperty.name">
                        <el-select
                          v-if="itemProperty.type === 'cityid' && !menuItem.locationId"
                          v-model="menuData[menuDataSourceKey][screenIndex][menuItem.id]"
                          :value-key="'placeId'"
                          filterable
                          remote
                          :remote-method="handleCityOptionsSearch"
                          :loading="cityOptionsSearchLoading"
                          :popper-class="'cstm-selectbox-grey-popper city-autosearch-proper-class'"
                          @change="handleMenuItemCityChange($event)"
                          class="cstm-selectbox-grey">

                          <el-option
                            v-for="city in cityOptions"
                            :key="city.placeId"
                            :label="city.description"
                            :value="city">
                          </el-option>
                        </el-select>

                        <!-- Selectbox for Weather -->
                        <div v-else class="selectbox-with-label">
                          <label>{{ $t('label.location') }}</label>
                          <el-select
                            v-model="menuData[menuDataSourceKey][screenIndex][menuItem.locationId]"
                            :value-key="'placeId'"
                            filterable
                            remote
                            :remote-method="handleCityOptionsSearch"
                            :loading="cityOptionsSearchLoading"
                            :popper-class="'cstm-selectbox-grey-popper city-autosearch-proper-class'"
                            @change="handleMenuItemCityChange($event)"
                            class="cstm-selectbox-grey">
                          <el-option
                            v-for="city in cityOptions"
                            :key="city.placeId"
                            :label="city.description"
                            :value="city">
                            </el-option>
                          </el-select>
                        </div>

                        <p class="hint-text" v-if="menuItem.locationId && !isItemInEditMode(menuItem)">{{ $t('template.weatherLocationSettingsHint') }}</p>
                      </el-form-item>

                      <el-form-item v-if="itemProperty.type === 'timezone'" :prop="itemProperty.name">
                        <div class="selectbox-with-label">
                          <label>{{ $t('templates.timezone') }}</label>
                          <el-select
                            v-if="menuData[menuDataSourceKey][screenIndex][menuItem.id]"
                            v-model="menuData[menuDataSourceKey][screenIndex][menuItem.id][itemProperty.name]"
                            filterable
                            @change="handleMenuItemChange($event)"
                            :popper-class="'cstm-selectbox-grey-popper'"
                            class="cstm-selectbox-grey">

                            <el-option
                              v-for="(tz, tzIndx) in timeZone"
                              :key="tzIndx"
                              :value="tz.value"
                              :label="tz.label">
                            </el-option>
                          </el-select>
                        </div>
                      </el-form-item>

                      <!-- Grouped Items -->
                      <el-form-item v-if="itemProperty.type === 'uiGroupedMenuItems'" :prop="itemProperty.name" class="ui-grouped-items">
                        <!-- Color group -->
                        <div v-if="itemProperty.name === 'uiGroupedMenuItemsColor'" :class="['ui-grouped-items-wrapper colors']">
                          <template v-for="(itemProperty, indx) in itemProperty.properties" :key="indx">
                            <!-- This is only for the default blank page since the rest of the designs are still pending, will be updated to a more dynamic label once finalized -->
                            <label class="section-label" v-if="itemProperty.name === 'frameBackgroundColor' || (itemProperty.name === 'backgroundColor' && isOverlayItem(menuItem.id))">{{$t('template.background')}}</label>
                            <div v-if="itemProperty.colortype === 'text'"
                            class="cstm-color-picker-wrapper">
                              <div :class="['color-item', 'color-type-'+itemProperty.colortype, menuItem.style]">
                                <el-color-picker
                                  ref="colorPicker"
                                  v-if="menuData[menuDataSourceKey] [screenIndex][menuItem.id]"
                                  size="large"
                                  color-format="rgb"
                                  :model-value="menuData[menuDataSourceKey][screenIndex][menuItem.id][itemProperty.name]"
                                  @active-change="handleColorSwatchChange($event, menuData[menuDataSourceKey][screenIndex][menuItem.id], itemProperty.name)"
                                  :predefine="predefineColors"
                                  :popper-class="getColorPickerPopperClass(itemProperty)">
                                </el-color-picker>
                              </div>
                            </div>

                            <div v-else class="cstm-color-picker-wrapper">
                              <div :class="['color-item', 'color-type-'+itemProperty.colortype, menuItem.style]">
                                <el-color-picker
                                  ref="colorPicker"
                                  v-if="menuData[menuDataSourceKey] [screenIndex][menuItem.id]"
                                  size="large"
                                  color-format="rgb"
                                  :model-value="menuData[menuDataSourceKey][screenIndex][menuItem.id][itemProperty.name]"
                                  @active-change="handleColorSwatchChange($event, menuData[menuDataSourceKey][screenIndex][menuItem.id], itemProperty.name)"
                                  :show-alpha="itemProperty.name === 'backgroundColor'"
                                  :predefine="predefineColors"
                                  :popper-class="getColorPickerPopperClass(itemProperty)">
                                </el-color-picker>
                              </div>
                            </div>
                            <p class="hint-text" v-if="menuItem.style === 'box' && !isItemInEditMode(menuItem)">{{ $t('template.shapeSettingsHint') }}</p>
                          </template>
                        </div>

                        <!-- Date and Time -->
                        <div v-if="itemProperty.name === 'uiGroupedMenuItemsDateAndTime'" :class="['ui-grouped-items-wrapper date-and-time']">
                          <template v-for="(groupedPropItem, indx) in itemProperty.properties">
                            <!-- Date Element -->
                            <el-form-item
                              v-if="groupedPropItem.name === 'date'"
                              :key="indx" :prop="groupedPropItem.name"
                              :label="groupedPropItem.label"
                              class="date-picker grouped">
                              <div class="date-picker-icon"></div>
                              <div class="flex w-full border border-[#dcdfe6] rounded-sm">
                                <el-date-picker
                                  :prop="groupedPropItem.name"
                                  :ref="`form-el-${groupedPropItem.name}`"
                                  v-if="menuData[menuDataSourceKey][screenIndex][menuItem.id]"
                                  :model-value="menuData[menuDataSourceKey][screenIndex][menuItem.id][groupedPropItem.name]"
                                  @update:model-value="(value) => handleDateTimeValueChange(value, menuItem.id, groupedPropItem.name)"
                                  :clearable="false"
                                  value-format="YYYY-MM-DD"
                                  format="DD MMM YY"
                                  type="date"
                                  :placeholder="''"
                                  class="cstm-datepicker-grey">
                                </el-date-picker>
                                <div
                                  v-if="menuData[menuDataSourceKey][screenIndex][menuItem.id][groupedPropItem.name]"
                                  class="clear-button px-1 cursor-pointer flex opacity-[0.3] items-center"
                                  @click="resetDateTimeValue(menuItem.id, groupedPropItem.name)">
                                  <el-icon><CircleClose /></el-icon>
                                </div>
                              </div>
                            </el-form-item>

                            <!-- Time Element -->
                            <el-form-item v-if="groupedPropItem.name === 'time'"
                              :key="indx" :prop="groupedPropItem.name"
                              :label="groupedPropItem.label"
                              class="time-picker grouped">
                              <timepicker-with-timeformat>
                                <div class="flex w-full border border-[#dcdfe6] rounded-sm">
                                  <el-time-picker
                                    v-if="menuData[menuDataSourceKey][screenIndex][menuItem.id]"
                                    v-model="menuData[menuDataSourceKey][screenIndex][menuItem.id][groupedPropItem.name]"
                                    :format="countdownPropertyTimeFormat"
                                    value-format="HH:mm"
                                    :clearable="false"
                                    :id="'editProjectTimePicker'"
                                    :ref="'editProjectTimePicker'"
                                    :placeholder="''"
                                    :prefix-icon="''"
                                    :popper-class="'edit-project-time-picker-dropdown'"
                                    @blur="handleMenuItemChange"
                                    class="time-picker">
                                  </el-time-picker>
                                  <div
                                    v-if="menuData[menuDataSourceKey][screenIndex][menuItem.id][groupedPropItem.name]"
                                    class="clear-button px-1 cursor-pointer flex opacity-[0.3] items-center"
                                    @click="resetDateTimeValue(menuItem.id, groupedPropItem.name)">
                                    <el-icon><CircleClose /></el-icon>
                                  </div>
                                </div>
                              </timepicker-with-timeformat>
                            </el-form-item>
                          </template>
                        </div>

                        <!-- Text format group -->
                        <div
                          v-if="itemProperty.name === 'uiGroupedMenuItemsTextFormat'"
                          class="ui-grouped-items-wrapper text-format flex flex-wrap gap-1 items-center"
                          :class="{
                            'no-font-size': !itemProperty.hasFontSizeEl
                          }">
                          <template v-for="groupedPropItem in itemProperty.properties">
                            <el-select v-if="groupedPropItem.type === 'choice' && groupedPropItem.name === 'fontWeight' && menuData[menuDataSourceKey][screenIndex][menuItem.id]"
                              :key="`${groupedPropItem.name}-choice`"
                              :model-value="getFontWeightName(menuItem.id)"
                              :placeholder="groupedPropItem.name"
                              @change="handleMenuItemChange($event, groupedPropItem.type, groupedPropItem.name, menuItem.id)"
                              :popper-class="'cstm-selectbox-grey-popper'"
                              :class="['cstm-selectbox-grey', groupedPropItem.name]">
                              <!-- Options from Property Values -->
                              <el-option v-for="(itemPropertyValue, itemPropValKey) in groupedPropItem.values"
                                :key="itemPropValKey"
                                :label="itemPropertyValue.name"
                                :value="itemPropertyValue.value">
                              </el-option>
                            </el-select>

                            <!-- Select Box -->
                            <el-select v-else-if="groupedPropItem.type === 'choice' && menuData[menuDataSourceKey][screenIndex][menuItem.id]"
                              :key="`${groupedPropItem.name}-choice`"
                              v-model="menuData[menuDataSourceKey][screenIndex][menuItem.id][groupedPropItem.name]"
                              :placeholder="groupedPropItem.name"
                              @change="handleMenuItemChange($event, groupedPropItem.type, groupedPropItem.name)"
                              :popper-class="'cstm-selectbox-grey-popper'"
                              :class="['cstm-selectbox-grey', groupedPropItem.name]">
                              <!-- Options from Property Values -->
                              <el-option v-for="(itemPropertyValue, itemPropValKey) in groupedPropItem.values"
                                :key="itemPropValKey"
                                :label="itemPropertyValue.name"
                                :value="itemPropertyValue.value">
                              </el-option>
                            </el-select>

                            <!-- Bold Switch -->
                            <el-button
                              v-else-if="groupedPropItem.name === 'fontBold'
                              && groupedPropItem.type === 'switch'
                              && menuData[menuDataSourceKey][screenIndex][menuItem.id]"
                              :key="`${groupedPropItem.name}-bold`"
                              class="bold bg-none px-2 h-auto"
                              :class="{ 'bg-[#5b7aef] active': menuData[menuDataSourceKey][screenIndex][menuItem.id]['fontWeight'] >= Number(FONT_WEIGHT_BOLD) }"
                              @click="handleMenuItemChange($event, groupedPropItem.type, groupedPropItem.name, menuItem.id)"
                            >
                              <span></span>
                            </el-button>

                            <!-- Italic Switch -->
                            <el-button
                              v-else-if="groupedPropItem.name === 'fontStyle'
                              && groupedPropItem.type === 'switch'
                              && menuData[menuDataSourceKey][screenIndex][menuItem.id]"
                              :key="`${groupedPropItem.name}-italic`"
                              class="italic bg-none px-2 h-auto mx-0"
                              :class="{ 'bg-[#5b7aef] active': menuData[menuDataSourceKey][screenIndex][menuItem.id]['fontStyle'] === FONT_ITALIC }"
                              @click="handleMenuItemChange($event, groupedPropItem.type, groupedPropItem.name, menuItem.id)"
                            >
                              <span></span>
                            </el-button>

                            <!-- Radio button -->
                            <el-radio-group
                              v-else-if="groupedPropItem.type === 'switch' && menuData[menuDataSourceKey][screenIndex][menuItem.id]"
                              :key="`${groupedPropItem.name}-switch`"
                              :modelValue="menuData[menuDataSourceKey][screenIndex][menuItem.id][groupedPropItem.name]"
                              @change="handleSwitchValueChange($event, menuDataSourceKey, screenIndex, menuItem.id, groupedPropItem.name, groupedPropItem.type)"
                              :class="['cstm-radio-grey', groupedPropItem.name]">

                              <el-radio-button v-for="(itemPropertyValue, itemPropValKey) in groupedPropItem.values"
                                :key="itemPropValKey"
                                size="small"
                                :value="itemPropertyValue.value"
                                :class="{
                                    [`${groupedPropItem.name}-${itemPropertyValue.value}`]: true,
                                    'is-focus': menuData[menuDataSourceKey][screenIndex][menuItem.id][groupedPropItem.name] === itemPropertyValue.value
                                  }">
                                <template v-if="itemPropertyValue.nameTranslated">{{itemPropertyValue.nameTranslated}}</template>
                                <template v-else>{{itemPropertyValue.name.trim()}}</template>
                              </el-radio-button>
                            </el-radio-group>
                          </template>
                        </div>

                        <!-- Text align group -->
                        <div v-if="itemProperty.name === 'uiGroupedMenuItemsTextAlign'" :class="['ui-grouped-items-wrapper text-align', { 'extended-menu-item': itemProperty.extended }]">
                          <template v-for="(groupedPropItem, indx) in itemProperty.properties">
                            <!-- Radio button -->
                            <el-radio-group v-if="groupedPropItem.type === 'switch' && menuData[menuDataSourceKey][screenIndex][menuItem.id]"
                              :key="indx"
                              :model-value="menuData[menuDataSourceKey][screenIndex][menuItem.id][groupedPropItem.name]"
                              @change="handleSwitchValueChange($event, menuDataSourceKey, screenIndex, menuItem.id, groupedPropItem.name, groupedPropItem.type)"
                              :class="['cstm-radio-grey', groupedPropItem.name]">
                              <el-radio-button v-for="(itemPropertyValue, itemPropValKey) in groupedPropItem.values"
                                :key="itemPropValKey"
                                size="small"
                                :class="`${groupedPropItem.name}-${itemPropertyValue.value}`"
                                :label="itemPropertyValue.value"
                                :value="itemPropertyValue.value">
                                <template v-if="itemPropertyValue.nameTranslated">{{itemPropertyValue.nameTranslated}}</template>
                                <template v-else>{{itemPropertyValue.name.trim()}}</template>
                              </el-radio-button>
                            </el-radio-group>
                          </template>
                        </div>
                      </el-form-item>
                    </div>

                    <div v-if="!isProjectTemplateFromPDFFile && menuItem.id !== 'settings' && !isItemInEditMode(menuItem) && getEffectPropsFromMenuItem(menuItem).length" class="effects-wrapper">
                      <div class="divider"></div>
                      <label class="effects-label">{{ $t('template.effects') }}</label>
                      <div v-for="effectMenuItem in getEffectPropsFromMenuItem(menuItem)">
                        <div class="effects-item">
                          <div :class="['cstm-radio-grey', {'radio-constant-width': !effectMenuItem.small, 'auto-button-width': effectMenuItem.small},
                            { 'extended-menu-item': effectMenuItem.extended }]">
                            <el-radio-group
                              v-if="menuData[menuDataSourceKey][screenIndex][menuItem.id]"
                              v-model="menuData[menuDataSourceKey][screenIndex][menuItem.id][effectMenuItem.name]"
                              :class="effectMenuItem.name"
                              @change="handleMenuItemEffectsChange($event, effectMenuItem.name, menuItem.id)"
                            >

                              <el-radio-button v-for="(effectMenuItemPropertyValue, effectMenuItemPropValKey) in effectMenuItem.values"
                                :key="effectMenuItemPropValKey"
                                size="small"
                                :value="effectMenuItemPropertyValue.value"
                                :class="{
                                    [`${effectMenuItem.name}-${effectMenuItemPropertyValue.value}`]: true,
                                    'is-focus': menuData[menuDataSourceKey][screenIndex][menuItem.id][effectMenuItem.name] === effectMenuItemPropertyValue.value
                                  }">
                                  <template v-if="effectMenuItemPropertyValue.nameTranslated">{{effectMenuItemPropertyValue.nameTranslated}}</template>
                                  <template v-else>{{effectMenuItemPropertyValue.name.trim()}}</template>
                              </el-radio-button>
                            </el-radio-group>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Media Properties -->
                  <template v-if="isMediaItem(menuItem.id, menuItem) || isOverlayItem(menuItem.id) || isWarningItem(menuItem.id)">
                    <!-- Media Frame Fitting -->
                    <div class="section-wrapper media-frame-fitting" v-if="!isOverlayItem(menuItem.id) && !isMediaItemAsLogo(menuItem) && !isMediaStream(menuItem.id)">
                      <label class="section-label">{{$t('template.frameFitting')}}</label>

                      <template v-for="(itemProperty, iPropKey) in menuItem.properties">
                        <!-- Image Effects -->
                        <template v-if="isMediaEffectsProperties(itemProperty, menuItem.id) && isMediaEffectsPropertiesVisible(itemProperty)">
                          <div :key="iPropKey" class="effects-wrapper">
                            <div class="divider"></div>
                            <label class="effects-label">{{ $t('template.imageEffects') }}</label>

                            <el-radio-group
                              :key="iPropKey"
                              v-if="itemProperty.type === 'switch' && menuData[menuDataSourceKey][screenIndex][menuItem.id]"
                              :model-value="menuData[menuDataSourceKey][screenIndex][menuItem.id][itemProperty.name]"
                              @change="handleSwitchValueChange($event, menuDataSourceKey, screenIndex, menuItem.id, itemProperty.name, itemProperty.type)"
                              :class="['cstm-radio-grey', itemProperty.name, { 'extended-menu-item': itemProperty.extended }]">

                              <el-radio-button v-for="(itemPropertyValue, itemPropValKey) in itemProperty.values"
                                :key="itemPropValKey"
                                :class="`${itemProperty.name}-${itemPropertyValue.value}`"
                                :value="itemPropertyValue.value"
                                size="small">
                                <template v-if="itemPropertyValue.nameTranslated">{{itemPropertyValue.nameTranslated}}</template>
                                <template v-else>{{itemPropertyValue.name.trim()}}</template>
                              </el-radio-button>
                            </el-radio-group>
                          </div>
                        </template>
                        <template v-else>
                          <el-radio-group
                            :key="iPropKey"
                            v-if="itemProperty.type === 'switch' && isMediaFittingProperties(itemProperty) && menuData[menuDataSourceKey][screenIndex][menuItem.id]"
                            :model-value="menuData[menuDataSourceKey][screenIndex][menuItem.id][itemProperty.name]"
                            @change="handleSwitchValueChange($event, menuDataSourceKey, screenIndex, menuItem.id, itemProperty.name, itemProperty.type)"
                            :class="['cstm-radio-grey', itemProperty.name, { 'extended-menu-item': itemProperty.extended }]">

                            <template v-for="(itemPropertyValue, itemPropValKey) in itemProperty.values" :key="itemPropValKey">
                              <el-tooltip
                                :content="itemPropertyValue.nameTranslated || itemPropertyValue.name.trim()"
                                :popper-class="'custom-tooltip-popper-filters'"
                                :show-arrow="false"
                                effect="light"
                                class="item"
                                placement="bottom">
                                <el-radio-button
                                  size="small"
                                  :class="`${itemProperty.name}-${itemPropertyValue.value}`"
                                  :value="itemPropertyValue.value">
                                  {{ itemPropertyValue.value }}
                                </el-radio-button>
                              </el-tooltip>
                            </template>
                          </el-radio-group>
                        </template>
                      </template>
                    </div>

                    <!-- Media Video Settings -->
                    <div v-if="isVideoMedia(menuItem.id) && !isOverlayItem(menuItem.id) && !isMediaItemAsLogo(menuItem)" class="section-wrapper media-video-settings">
                      <label class="section-label">{{$t('template.videoSettings')}}</label>

                      <template v-for="(itemProperty, iPropKey) in menuItem.properties">
                        <el-radio-group
                          :key="iPropKey"
                          v-if="itemProperty.type === 'switch' && isMediaVideoSettingsProperties(itemProperty) && menuData[menuDataSourceKey][screenIndex][menuItem.id]"
                          :model-value="menuData[menuDataSourceKey][screenIndex][menuItem.id][itemProperty.name]"
                          @change="handleSwitchValueChange($event, menuDataSourceKey, screenIndex, menuItem.id, itemProperty.name, itemProperty.type)"
                          :class="['cstm-radio-grey', itemProperty.name, { 'extended-menu-item': itemProperty.extended }]">

                          <el-radio-button v-for="(itemPropertyValue, itemPropValKey) in itemProperty.values"
                            :key="itemPropValKey"
                            size="small"
                            :class="`${itemProperty.name}-${itemPropertyValue.value}`"
                            :label="itemPropertyValue.value"
                            :value="itemPropertyValue.value">
                            <template v-if="itemPropertyValue.nameTranslated">{{itemPropertyValue.nameTranslated}}</template>
                            <template v-else>{{itemPropertyValue.name.trim()}}</template>
                          </el-radio-button>
                        </el-radio-group>
                      </template>
                    </div>

                    <!-- Media Stream URL -->
                    <div class="section-wrapper media-stream-url" v-if="isMediaStream(menuItem.id) && isMediaStreamHasURL(menuItem)">
                      <label class="section-label">{{$t('template.stream')}}</label>

                      <template v-for="(itemProperty, iPropKey) in menuItem.properties">
                        <el-form-item v-if="itemProperty.type === 'string' && itemProperty.name === 'href'" :prop="itemProperty.name" :key="iPropKey" class="left-label-default-href">
                          <label class="label-property">{{$t('template.url')}}</label>

                          <el-input
                            v-if="menuData[menuDataSourceKey][screenIndex][menuItem.id]"
                            v-model="menuData[menuDataSourceKey][screenIndex][menuItem.id][itemProperty.name]"
                            @change="handleMenuItemChange($event)"
                            :ref="`${menuItem.id + &quot;_&quot; + itemProperty.name}-input`"
                            @focus="handleInputElFocus(`${menuItem.id + &quot;_&quot; + itemProperty.name}-input`)"
                            class="cstm-input-grey text-left!"
                          >
                          </el-input>
                        </el-form-item>
                      </template>
                    </div>

                    <!-- Media Uploader -->
                    <div class="section-wrapper media-uploader">
                      <label class="section-label">{{$t('template.changeMedia')}}</label>
                      <el-tooltip
                        :key="'media-app-uploader-tooltip'"
                        :content="$t('label.upload')"
                        :popper-class="'custom-tooltip-popper-filters'"
                        :show-arrow="false"
                        effect="light"
                        class="item"
                        placement="bottom">
                        <button @click="openMediaPickerDialog(menuItem.id)" id="mediaFileUploadIcon" type="button" class="cstm-icon-btn-medium normal-opacity file-upload-thin"></button>
                      </el-tooltip>
                    </div>
                  </template>

                  <!-- Duration -->
                  <div v-if="menuItem.id === 'settings'">
                    <el-form-item
                      v-for="(itemProperty, iPropKey) in filterByPropertyName(menuItem.properties, 'dur')"
                      :key="iPropKey"
                      class="section-wrapper"
                      :prop="menuItem.name"
                      id="duration"
                    >
                      <label
                        v-if="menuItem.name"
                        class="section-label"
                      >
                        {{menuItem.name}}
                      </label>
                      <div class="input-wrapper">
                        <duration-input
                          data-component-element-id="project-template-duration-input"
                          :model-value="menuData[menuDataSourceKey][screenIndex][menuItem.id].dur"
                          @blur="onFocusOut"
                          @update:model-value="onComplete($event, menuItem.id)"
                          :default-value="defaultMediaDurationFormatted"
                        />
                      </div>
                    </el-form-item>
                  </div>

                  <!-- Tags -->
                  <div v-if="menuItem.type === 'tags'" class="no-property project-template-tags-wrapper section-wrapper" :id="menuItem.id + &quot;_&quot; + menuItem.name">
                    <label v-if="menuItem.name" class="section-label">{{menuItem.name}}</label>
                    <tags-menu-item
                      :accessorComponentProp="'projectTemplateMenu'"
                      :tagsSummaryProp="tagsSummaryForSuggestions"
                      :tagsProp="menuData[menuDataSourceKey][screenIndex][menuItem.id]"
                      :elClassProp="'project-template-tags'"
                      :disabledEditTagItemsProp="disabledEditTagItems"
                      @tags-change="handleMenuItemChange($event, menuItem.type, menuItem.name)">
                    </tags-menu-item>
                  </div>

                  <!-- Playtimes -->
                  <div v-if="menuItem.type === 'schedule' && menuItem.id === 'playTimes'" class="no-property project-template-playTimes-wrapper" :id="menuItem.id + &quot;_&quot; + menuItem.name">
                    <schedule-playtime-menu-item
                      ref="schedulePlaytime"
                      :parentAccessorComponentProp="'projectTemplateMenu'"
                      :mediaSelectionProp="[]"
                      :mediaPropertiesFormDataProp="playTimePropertiesForm"
                      @schedule-playtime-menu-item-change="handleMenuItemChange($event, 'schedulePlaytimes', menuItem.name)">
                    </schedule-playtime-menu-item>
                  </div>
                </div>
              </el-form-item>
            </el-col>
          </el-form-item>
        </template>

        <!-- No Menu Items-->
        <template v-else>
          <el-form-item class="property">
            <el-col class="content common">
              <el-form-item class="form-item single-type">
                <div class="editable">
                  <!-- Alignment -->
                  <div
                    v-if="isAlignElementVisible"
                    class="no-property section-wrapper">
                    <label class="section-label">{{ $t('templates.alignElements') }}</label>

                    <align-elements-menu-item @select-alignment="handleAlignElementChange"></align-elements-menu-item>
                  </div>
                </div>
              </el-form-item>
            </el-col>
          </el-form-item>
        </template>

        <!-- Extended Menu Items Button action -->
        <template v-if="countMenuItemsWithExtendedFlag > 0">
          <el-button v-if="extendedButtonAction === 'more'" class="extend-btn more" @click="handleExtendedMenuItemVisibility('more')"></el-button>
          <el-button v-if="false" class="extend-btn less" @click="handleExtendedMenuItemVisibility('less')"></el-button>
        </template>
      </el-form>
    </div>

    <!-- Media List Dialog -->
    <div class="cstm-modal-media-list">
      <el-dialog
        v-if="mediaListDialog.isVisible"
        id="mediaDialogInEditProjectPage"
        :z-index="999"
        :model-value="mediaListDialog.isVisible"
        :close-on-click-modal="false"
        :class="{'cstm-modal-media-list': true, 'vertical': (projectOrientation === 'vertical')}"
        :modal="false"
        @close="handleDialogClose">

        <media-list
          :accessorComponentProp="'editProjectTemplate'"
          :defaultMediaTypeFilterProp="mediaListDialog.filterType"
          :mediaSelectionProp="mediaListDialog.mediaSelection"
          :mediaTypeOptionsProp="mediaListDialog.filterTypeOptions"
          :isMediaListVisibleProp="mediaListDialog.isVisible"
          :showProjectFilterOptionProp="showProjectFilterInMediaListModal"
          :tagSliderledTagItemProp="mediaListTagSliderLedTagItem"
          @media-list-change="handleMediaListChange($event)">
        </media-list>
      </el-dialog>
    </div>
  </div>
</template>
<script src="./project-template-menu.js"></script>
<style lang="scss" src="./project-template-menu.scss"></style>
